import {useContext} from 'react'

import PropTypes from 'prop-types'

import {atomIconSizes} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import MoleculeNotification, {
  moleculeNotificationAutoClose,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  VARIATIONS as moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import IconInfoOutline from '@adv-mt/mt-svg-icons/lib/InfoOutline.js'

const TITLE_LITERAL_KEY = 'VEHICLE_RESERVATION.NOT_AVAILABLE_NOTIFICATION_TITLE'
const DESCRIPTION_LITERAL_KEY = 'VEHICLE_RESERVATION.NOT_AVAILABLE_NOTIFICATION_DESCRIPTION'

const NotificationReservationAdNotAvailable = ({onClose}) => {
  const {i18n} = useContext(Context)

  return (
    <MoleculeNotification
      autoClose={moleculeNotificationAutoClose.manual}
      icon={<IconInfoOutline size={atomIconSizes.small} />}
      onClose={onClose}
      roundedCorners={moleculeNotificationBorderSizes.medium}
      show
      showCloseButton
      type={moleculeNotificationTypes.info}
      variation={moleculeNotificationVariations.positive}
    >
      <div>
        <strong>{i18n.t(TITLE_LITERAL_KEY)}</strong>
        <br />
        {i18n.t(DESCRIPTION_LITERAL_KEY)}
      </div>
    </MoleculeNotification>
  )
}

NotificationReservationAdNotAvailable.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default NotificationReservationAdNotAvailable
